import React, { useState } from "react";
import { Col, Row, Table } from "antd";
import CustomCard from "../d-reusable/CustomCard";

import { useNavigate } from "react-router-dom";
import CustomBarChart from "./charts/CustomBarChart";
import { dentalBasePath, formateDateAndTime } from "../../../helper";
import { useDispatch } from "react-redux";
import {
  _setProjectDetailsCaseTab,
  _setProjectDetailsTab,
} from "../../../redux/actions/generalAction";

const ProjectGraphAndTable = ({ data }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const recentAmPmCases = data?.recent_cases || [];
  const monthly_projects = data?.monthly_projects || [];

  const handleOpenSingleCaseDetail = (record) => {
    dispatch(_setProjectDetailsCaseTab("all"));
    dispatch(_setProjectDetailsTab("cases"));
    // navigate(`${dentalBasePath}/projects/details/${record.project_id}`);
    navigate(`${dentalBasePath}/projects/details`, {
      state: { projectId: record.project_id },
    });
  };
  const columns = [
    {
      title: "Project Name",
      dataIndex: "title",
      key: "title",
    },

    {
      title: "Type",
      key: "case_type",
      render: (text, record) => record?.case_type?.toUpperCase(),
    },
    {
      title: "Date",
      key: "created_at",
      render: (text, record) => formateDateAndTime(record?.created_at),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (text, record) => {
        return (
          <div
            onClick={() => handleOpenSingleCaseDetail(record)}
            style={{
              color: "#20C3FF",
              fontSize: 14,
              fontFamily: "Poppins-Medium",
              cursor: "pointer",
            }}
          >
            View
          </div>
        );
      },
    },
  ];
  return (
    <div>
      <Row gutter={[20, 20]}>
        <Col md={12} sm={24} xs={24}>
          <CustomBarChart data={monthly_projects} />
        </Col>

        <Col md={12}>
          <CustomCard>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "20px 10px",
              }}
            >
              <h6
                style={{
                  padding: 0,
                  margin: 0,
                  fontSize: 18,
                  fontFamily: "Poppins-Medium",
                }}
              >
                Recent AM/PM Cases
              </h6>
              {/* <CustomLinkButton title={" View All"} /> */}
            </div>

            <Table
              dataSource={recentAmPmCases}
              columns={columns}
              pagination={false}
              // rowClassName="custom-table-row" // Add custom class to row
              style={{ height: "400px", overflowX: "scroll" }}
            />
          </CustomCard>
        </Col>
      </Row>
    </div>
  );
};

export default ProjectGraphAndTable;
